import { MenuItem, QUERY_KEYS } from '@24i/nxg-sdk-photon/src';
import { useQuery } from 'react-query';
import { useAppStructureData } from '@24i/nxg-sdk-smartott-shared/src/context/AppStructureData';
import { useAppConfigQuery } from '@24i/nxg-sdk-smartott-shared/src/hooks/query/useAppConfigQuery';

const getMenuConfigQueryKey = (menuId?: string) => [QUERY_KEYS.menu, menuId];

export const useMenuConfigQuery = () => {
    const client = useAppStructureData();
    const { appSettings } = useAppConfigQuery();
    const menuId = appSettings?.features?.menus?.main || undefined;

    const { isLoading, data, refetch } = useQuery<MenuItem[]>(
        getMenuConfigQueryKey(menuId),
        () => client.fetchMenu(menuId, appSettings),
        {
            enabled: Boolean(appSettings),
        }
    );

    return {
        isLoading,
        menuConfig: data,
        refetch,
    };
};
